// ============================================================
// SpeedmasterCore.ScrollCarousel
//
// Premium scroll carousel — Ubiquiti-style UX.
// Self-executing AMD module. Uses MutationObserver to detect
// .sm-scroll-carousel elements as they appear in the DOM
// (SPA-aware — handles async view rendering).
//
// Behaviors:
//   1. Arrows hidden until hover (CSS), JS controls boundary hide
//   2. Arrow click scrolls 3 cards with smooth animation
//   3. Trackpad/mouse = native smooth scroll (no snapping)
//   4. Left arrow hidden at start, right arrow hidden at end
//
// Pairs with .sm-scroll-* CSS classes in the theme.
// ============================================================

define('SpeedmasterCore.ScrollCarousel', [
	'underscore'
], function (_) {
	'use strict';

	var CARD_GAP = 16;
	var SCROLL_COUNT = 3;

	// --- Initialize a single carousel ---

	function initCarousel(el) {
		el.setAttribute('data-sm-init', 'true');

		var track = el.querySelector('.sm-scroll-track');
		var prevBtn = el.querySelector('.sm-scroll-prev');
		var nextBtn = el.querySelector('.sm-scroll-next');

		if (!track) {
			return;
		}

		// --- Arrow visibility based on scroll position ---

		function updateArrows() {
			var scrollLeft = track.scrollLeft;
			var maxScroll = track.scrollWidth - track.clientWidth;
			var atStart = scrollLeft <= 1;
			var atEnd = scrollLeft >= maxScroll - 1;

			if (prevBtn) {
				if (atStart) {
					prevBtn.classList.add('sm-hidden');
				} else {
					prevBtn.classList.remove('sm-hidden');
				}
			}

			if (nextBtn) {
				if (atEnd) {
					nextBtn.classList.add('sm-hidden');
				} else {
					nextBtn.classList.remove('sm-hidden');
				}
			}
		}

		var debouncedUpdate = _.debounce(updateArrows, 50);

		// Listen for scroll events on the track
		track.addEventListener('scroll', debouncedUpdate);

		// Recalculate on window resize (card widths change)
		window.addEventListener('resize', debouncedUpdate);

		// --- Arrow click handlers ---

		function getScrollDistance() {
			var firstChild = track.children[0];
			var cardWidth = firstChild ? firstChild.offsetWidth : 200;
			return (cardWidth + CARD_GAP) * SCROLL_COUNT;
		}

		if (prevBtn) {
			prevBtn.addEventListener('click', function (e) {
				e.preventDefault();
				track.scrollBy({
					left: -getScrollDistance(),
					behavior: 'smooth'
				});
			});
		}

		if (nextBtn) {
			nextBtn.addEventListener('click', function (e) {
				e.preventDefault();
				track.scrollBy({
					left: getScrollDistance(),
					behavior: 'smooth'
				});
			});
		}

		// --- Initial state ---
		// Delay to let content render before measuring
		setTimeout(updateArrows, 100);
		setTimeout(updateArrows, 500);
	}

	// --- MutationObserver: detect new carousels in the DOM ---

	function scanForCarousels() {
		var carousels = document.querySelectorAll('.sm-scroll-carousel:not([data-sm-init])');

		for (var i = 0; i < carousels.length; i++) {
			initCarousel(carousels[i]);
		}
	}

	var observer = new MutationObserver(function () {
		scanForCarousels();
	});

	// Start observing when DOM is ready
	if (document.body) {
		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
		// Scan for any already in DOM
		scanForCarousels();
	} else {
		document.addEventListener('DOMContentLoaded', function () {
			observer.observe(document.body, {
				childList: true,
				subtree: true
			});
			scanForCarousels();
		});
	}
});
